module.exports = __webpack_public_path__ + "static/media/REDCap_ETL_Technical_Demo.df70ded2.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/informatics/REDCap_ETL_Technical_Demo.pdf
// module id = 411
// module chunks = 0